import React, { useState } from 'react';
import ContactController from "./ContactController";
import "../../App.css";
import "./Dashboard.css";
import TopController from "./TopController";
import ScheduleController from "./ScheduleController";
import MusicController from "./MusicController";

const Dashboard = () => {
    const [activeScreen, setActiveScreen] = useState("Top");

    const renderScreen = () => {
        switch (activeScreen) {
            case "Top":
                return <TopController />;
            case "Contact":
                return <ContactController />;
            case "Schedule":
                return <ScheduleController />;
            case "Music":
                return <MusicController />;
            default:
                return <div>画面が見つかりません。</div>;
        }
    };

    return (
        <div className="App">
            <h1>Dashboard</h1>

            <div className="select-wrapper">
                <div className="select-content" onClick={() => setActiveScreen("Top")}>
                    Top
                </div>
                <div className="select-content" onClick={() => setActiveScreen("Contact")}>
                    Contact
                </div>
                <div className="select-content" onClick={() => setActiveScreen("Schedule")}>
                    Schedule
                </div>
                <div className="select-content" onClick={() => setActiveScreen("Music")}>
                    Music
                </div>
            </div>

            {renderScreen()}
        </div>
    );
};

export default Dashboard;
